import { connect } from "react-redux";
import { ApplicationState } from "store";
import {
    actionCreators,
    getAddedExtraPages,
    getCalendar,
} from "page/calendar/store";
import { ExtraPages } from "./extra-pages";

import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
    getPreviewedExtraPage,
} from "ui/store";

const mapStateToProps = (state: ApplicationState) => ({
    calendar: getCalendar(state),
    previewedExtraPage: getPreviewedExtraPage(state),
    activeComponent: getActiveNavigationComponent(state),
    addedExtraPages: getAddedExtraPages(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

const ConnectedExtraPages = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ExtraPages);

export { ConnectedExtraPages as ExtraPagesControlsAccordion };
